<template>
  <aside class="aside__top">
    <el-breadcrumb separator="/">
      <transition-group name="breadcrumb">
        <!-- 防止面包屑导航出现 首页/首页， v-if="route.name!='home'" -->
        <el-breadcrumb-item v-for="(route,i) in crumbList" :key="route.name" :to="{name:route.name}" v-if="route.name!='container'" :class="{'is-last-link':i==crumbList.length-1}">
          {{route.meta.name}}
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
  </aside>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data () {
    return {};
  },
  computed: {
    ...mapState(['crumbList'])
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.aside__top {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  background: #f5f5f5;
  margin-bottom: 10px;
}

.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.6s;
}

.breadcrumb-leave-active {
  position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/components/breadcrumb.vue